import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { MailService } from '@ascschool/services/mail/mail.service';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Subject } from 'rxjs';
import { PopUpComposeComponent } from './pop-up/pop-up-compose/pop-up-compose.component';

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.scss']
})
export class MailPageComponent implements OnInit {
  @ViewChild('table', { static: false }) elementTable: ElementRef;
  draftLength: number;
  heightMenu: number;
  tagId: number;
  mode: any;
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  isTag = false;
  commonFilter = new CommonFilter();
  tags:any = [];
  eventsSubject: Subject<any> = new Subject<any>();
  inboxUnread: number;
  constructor(
    private modalService: NzModalService,
    private service: MailService,
  ) { }

  ngOnInit() {
    this.mode = 'inbox';
    setTimeout(() => {
      this.emitEventToChild({id : 0});
    }, 1);
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = 100;
    this.getTag();
    this.loadDraftItems();
    this.getCountInboxUnRead();
  }
  ngAfterViewInit() {
    this.checkHeight();
  }
  checkHeight(){
    setTimeout(() => {
      this.heightMenu = this.elementTable.nativeElement.offsetHeight - 43;
    }, 1);
  }
  changeMode(event: string){
    this.mode = event;

    this.checkHeight();
  }
  changeModeInbox(event: string, tag){
    this.mode = event;
    this.checkHeight();
    if(tag && tag.id >= 0){
      setTimeout(() => {
        this.emitEventToChild(tag);
      }, 1);
      this.tagId = tag.id;
    }
  }
  openNewMail(): void {
    this.isResizdePopup = false;
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopUpComposeComponent,
      nzStyle: { top: '40px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzWidth: 1300,
      nzComponentParams: {
        mode: 'new'
      },
    });
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  getTag(){
    this.service.getTagPaging(this.commonFilter).subscribe((response) => {
      this.tags = response.results;
    });
  }
  loadDraftItems() {
    this.service.getMyDraftItems(this.commonFilter).subscribe((response: any) => {
      this.draftLength = response.rowCount;
    });
  }
  emitEventToChild(id: any) {
    this.eventsSubject.next(id);
  }
  handlerResizePopup(){
    this.isResizdePopup = !this.isResizdePopup;
    let width = 1300 + 'px';
    let height = this.caculateHeightPopup(window.innerHeight) + 'px';
    let maxheight = this.caculateHeightPopup(window.innerHeight) + 'px';
    let top = 30;
    if(this.isResizdePopup === true){
      width = window.innerWidth + 'px';
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.dialogRef.updateConfig({
      nzWidth: width,
      nzStyle: { 
        top: top + 'px',
      },
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: maxheight,
        height: height,
      }
    });
  }
  getCountInboxUnRead(){
    this.service.getCountUnread().subscribe((res: number)=>{
      this.service.refreshCountInboxUnread(res);
    });
    this.service.countInboxUnread.subscribe((res)=>{
      this.inboxUnread = res;
    })
  }
} 
